/**
 * File press-release-list.js.
 *
 * Handles press release list blocks.
 */
(function ($) {
	"use strict";

	$(document).ready(function () {
		var windowWidth = $(window).outerWidth();
		/*$(window).scroll(function () {
			let scrollPosition = $(window).scrollTop();

			$(".press-release-list__box").each(function () {
				let yearListHeight = $(this)
					.parents(".press-release-list")
					.find(".press-release-list__years-list")
					.outerHeight();
				let headerHeight = $(".site-header").outerHeight();
				if ($("#wpadminbar").length > 0) {
					headerHeight += $("#wpadminbar").outerHeight();
				}
				let pressReleaseBox = $(this);
				let pressReleaseBoxID = pressReleaseBox.attr("id");
				let defaultOffset = 767 < windowWidth ? 40 : 30;
				let pressReleaseBoxTop =
					pressReleaseBox.offset().top -
					headerHeight -
					yearListHeight -
					defaultOffset;

				if (scrollPosition >= pressReleaseBoxTop) {
					$(".press-release-list__years-list a").removeClass(
						"active"
					);
					$(
						'.press-release-list__years-list a[href="#' +
							pressReleaseBoxID +
							'"]'
					).addClass("active");
				}
			});
		});*/

		// Load more press
		$(document).on(
			"click",
			".press-release-list .press-read-more-btn-action",
			function () {
				let yearData = $(this).attr("data-year")
					? $(this).attr("data-year")
					: new Date().getFullYear();
				let year =
					"all" !== yearData
						? parseInt($(this).attr("data-year"))
						: "all";
				let titleColor = $(this).attr("data-title-color");
				let dateColor = $(this).attr("data-date-color");
				let paged = $(this).attr("data-page")
					? parseInt($(this).attr("data-page")) + 1
					: 1;
				let pressPerPage = $(this).attr("data-press-per-page")
					? parseInt($(this).attr("data-press-per-page"))
					: 5;
				let filterItem = $(this).parents(".press-release-list__box");
				pressReleaseListAjax(
					filterItem,
					year,
					paged,
					pressPerPage,
					titleColor,
					dateColor,
					true
				);
			}
		);

		$(document).on(
			"click",
			".press-release-list__years-list a",
			function () {
				let targetId = $(this).attr("href") || "";
				$(targetId).addClass("show").siblings().removeClass("show");
				$(this)
					.addClass("active")
					.parent()
					.siblings()
					.find("a")
					.removeClass("active");
				/*if ($(targetId).length > 0) {
					let headerHeight = $(".site-header").outerHeight();
					if ($("#wpadminbar").length > 0) {
						headerHeight += $("#wpadminbar").outerHeight();
					}
					if (
						$(
							$(this)
								.parents(".press-release-list")
								.find(".press-release-list__years-list")
						).length > 0
					) {
						headerHeight += $(this)
							.parents(".press-release-list")
							.find(".press-release-list__years-list")
							.outerHeight();
					}
					$("html, body").animate(
						{
							scrollTop: $(targetId).offset().top - headerHeight,
						},
						1000
					);
				}*/
				return false;
			}
		);
	});

	// Ajax For Press List Block
	function pressReleaseListAjax(
		filterItem,
		year,
		paged,
		pressPerPage,
		titleColor,
		dateColor,
		scrollInView = true
	) {
		filterItem
			.find(".press-release-list__row")
			.addClass("press-release-loading");
		jQuery.ajax({
			type: "POST",
			dataType: "json",
			data: {
				action: "efi_press_release_list",
				press_per_page: pressPerPage,
				year: year,
				ajax_nonce: siteConfig.ajax_nonce,
				paged: paged,
			},
			url: siteConfig.ajaxUrl,
			success: function (pressData) {
				let pressObj = pressData.data.result_press;

				if (pressObj && 0 < pressObj.length) {
					$.each(pressObj, function (key, item) {
						let pressItem = document.createElement("div");
						pressItem.setAttribute(
							"class",
							"press-release-list__item"
						);

						let imgSection = document.createElement("div");
						imgSection.setAttribute(
							"class",
							"press-release-list__img"
						);

						let pressImg = document.createElement("img");
						pressImg.setAttribute("src", item.document_img);
						pressImg.setAttribute("alt", item.title);

						imgSection.appendChild(pressImg);

						let contentSection = document.createElement("div");
						contentSection.setAttribute(
							"class",
							"press-release-list__cnt"
						);

						let pressDate = document.createElement("p");
						pressDate.setAttribute(
							"class",
							"press-release-list__date"
						);
						pressDate.innerHTML = item.press_date;

						if (dateColor) {
							pressDate.style.color = dateColor;
						}

						let pressTitle = document.createElement("h3");

						if (item.document_file) {
							let fileUrl = document.createElement("a");
							fileUrl.setAttribute("href", item.document_file);
							fileUrl.setAttribute("target", "_blank");
							fileUrl.innerHTML = item.title;
							pressTitle.appendChild(fileUrl);
						} else {
							pressTitle.innerHTML = item.title;
						}

						if (titleColor) {
							pressTitle.style.color = titleColor;
						}

						contentSection.appendChild(pressDate);
						contentSection.appendChild(pressTitle);

						pressItem.appendChild(imgSection);
						pressItem.appendChild(contentSection);

						filterItem
							.find(".press-release-list__row")
							.append(pressItem);
					});
				}

				let maxPages = pressData.data.max_pages;
				let items = filterItem.find(".press-release-list__row")[0];
				let loadMoreObj = filterItem.find(
					".press-read-more-btn-action"
				);
				if (items && 1 === paged) {
					while (items.firstChild) {
						items.removeChild(items.firstChild);
					}
				}

				loadMoreObj.attr("data-max-page", maxPages);
				loadMoreObj.attr("data-page", paged);
				if (maxPages > paged) {
					loadMoreObj.parents(".press-list-load-more").show();
				} else {
					loadMoreObj.parents(".press-list-load-more").hide();
				}

				if (scrollInView) {
					filterItem[0].scrollIntoView({
						behavior: "smooth",
						block: "end",
						inline: "nearest",
					});
				}
				filterItem
					.find(".press-release-list__row")
					.removeClass("press-release-loading");
			},
		});
	}
})(jQuery);
